import { SvgListProps } from "./types";

const SvgList = ({ name, background, fill, className = "" }: SvgListProps) => {
  switch (name) {
    case "Logo":
      return (
        <svg
          className={className}
          viewBox='0 0 88 33'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_367_1568)'>
            <path
              d='M43.9958 0.000131903C30.229 -0.0265865 16.4882 1.19395 2.94209 3.64674C2.94209 3.64674 0.0297852 4.10257 0.0297852 6.80843V25.313C0.0297852 27.8734 2.94209 28.368 2.94209 28.368C16.4693 30.9816 30.218 32.2808 43.9958 32.2474C57.7736 32.2809 71.5223 30.9817 85.0495 28.368C85.0495 28.368 87.9618 27.8734 87.9618 25.313V6.75993C87.9618 4.05407 85.0495 3.59825 85.0495 3.59825C71.502 1.1615 57.7611 -0.042801 43.9958 0.000131903'
              fill={background}
              stroke={fill}
              strokeWidth={2}
            />
            <path
              d='M14.8818 12.453H14.9303C15.3349 11.7311 15.9344 11.1374 16.6604 10.7395C17.3865 10.3417 18.2099 10.1558 19.0367 10.203H19.9007V14.5285C19.3045 14.2129 18.6324 14.0685 17.9591 14.1115C15.4546 14.1115 14.843 15.7699 14.843 17.9908V23.0437H10.3774V10.3679H14.8818V12.453Z'
              fill={fill}
            />
            <path
              d='M34.9961 17.4669H25.5117C25.4626 17.8492 25.5018 18.2376 25.6264 18.6024C25.751 18.9672 25.9576 19.2986 26.2304 19.5711C26.5032 19.8437 26.8349 20.0501 27.2001 20.1746C27.5652 20.299 27.954 20.3382 28.3367 20.2891C28.766 20.3273 29.1972 20.2416 29.5793 20.0422C29.9613 19.8427 30.278 19.538 30.4918 19.1641H34.8214C34.103 22.1609 31.2587 23.5187 28.3658 23.5187C24.1624 23.5187 21.0171 21.1426 21.0171 16.7298C21.0171 12.5013 23.9294 9.94092 28.0454 9.94092C32.4527 9.94092 34.9961 12.6662 34.9961 16.9917V17.4669ZM30.8121 14.8677C30.6614 14.2904 30.3233 13.7794 29.8508 13.4147C29.3782 13.0499 28.7979 12.852 28.2008 12.852C27.6036 12.852 27.0233 13.0499 26.5508 13.4147C26.0782 13.7794 25.7401 14.2904 25.5894 14.8677H30.8121Z'
              fill={fill}
            />
            <path
              d='M50.4893 17.4669H41.0049C40.9558 17.8492 40.995 18.2376 41.1196 18.6024C41.2442 18.9672 41.4508 19.2986 41.7236 19.5711C41.9964 19.8437 42.3281 20.0501 42.6932 20.1746C43.0584 20.299 43.4472 20.3382 43.8298 20.2891C44.2576 20.3254 44.6868 20.2387 45.0669 20.0394C45.447 19.8401 45.7621 19.5364 45.9752 19.1641H50.3146C49.5962 22.1609 46.7518 23.5187 43.859 23.5187C39.6555 23.5187 36.5103 21.1426 36.5103 16.7298C36.5103 12.5013 39.4226 9.94092 43.5386 9.94092C47.9459 9.94092 50.4893 12.6662 50.4893 16.9917V17.4669ZM46.3053 14.8677C46.1546 14.2904 45.8165 13.7794 45.3439 13.4147C44.8714 13.0499 44.2911 12.852 43.6939 12.852C43.0968 12.852 42.5165 13.0499 42.0439 13.4147C41.5714 13.7794 41.2333 14.2904 41.0826 14.8677H46.3053Z'
              fill={fill}
            />
            <path
              d='M77.9136 17.4669H68.4389C68.3898 17.8492 68.429 18.2376 68.5536 18.6024C68.6782 18.9672 68.8848 19.2986 69.1576 19.5711C69.4304 19.8437 69.7621 20.0501 70.1273 20.1746C70.4924 20.299 70.8812 20.3382 71.2639 20.2891C71.6916 20.3254 72.1208 20.2387 72.5009 20.0394C72.881 19.8401 73.1962 19.5364 73.4093 19.1641H77.7389C77.0205 22.1609 74.1762 23.5187 71.2833 23.5187C67.0799 23.5187 63.9346 21.1426 63.9346 16.7298C63.9346 12.5013 66.8469 9.94092 70.9629 9.94092C75.3702 9.94092 77.9136 12.6662 77.9136 16.9917V17.4669ZM73.7102 14.8677C73.5595 14.2904 73.2214 13.7794 72.7488 13.4147C72.2763 13.0499 71.696 12.852 71.0988 12.852C70.5017 12.852 69.9214 13.0499 69.4488 13.4147C68.9763 13.7794 68.6382 14.2904 68.4875 14.8677H73.7102Z'
              fill={fill}
            />
            <path
              d='M62.0122 14.4995C61.3514 13.9603 60.5346 13.6475 59.6824 13.6072C59.2739 13.6007 58.8682 13.6762 58.4896 13.8294C58.1109 13.9825 57.7669 14.2102 57.478 14.4988C57.1891 14.7874 56.9613 15.1311 56.808 15.5094C56.6547 15.8877 56.5791 16.2929 56.5856 16.701C56.5716 17.1186 56.6446 17.5346 56.7999 17.9225C56.9553 18.3104 57.1896 18.6618 57.488 18.9545C57.7865 19.2472 58.1426 19.4748 58.5337 19.6228C58.9248 19.7708 59.3424 19.836 59.76 19.8142C60.5901 19.8061 61.3896 19.4997 62.0122 18.9511L63.1577 22.1225C61.8952 23.0151 60.3844 23.49 58.8378 23.4802C57.9452 23.5087 57.056 23.3586 56.2223 23.0387C55.3887 22.7188 54.6275 22.2356 53.9835 21.6176C53.3395 20.9995 52.8257 20.259 52.4724 19.4397C52.119 18.6203 51.9332 17.7386 51.9259 16.8465C51.909 15.9185 52.0828 14.9969 52.4364 14.1386C52.7901 13.2803 53.3162 12.5036 53.9821 11.8565C54.6481 11.2093 55.4398 10.7055 56.3084 10.3761C57.1769 10.0466 58.1039 9.89865 59.0319 9.94123C60.5339 9.99521 61.9835 10.5062 63.1868 11.4057L62.0122 14.4995Z'
              fill={fill}
            />
          </g>
        </svg>
      );
    case "NegativeChevron":
      return (
        <svg
          className='w-4 h-4'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M6 9L12 15L18 9'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          ></path>
        </svg>
      );
    case "PositiveChevron":
      return (
        <svg
          className='w-4 h-4'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M18 15L12 9L6 15'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          ></path>
        </svg>
      );
    case "ChevronUp":
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className={className}
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M5 15l7-7 7 7'
          />
        </svg>
      );
    case "ChevronDown":
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className={className}
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          strokeWidth='2'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M19 9l-7 7-7-7'
          />
        </svg>
      );
    case "SearchIcon":
      return (
        <svg
          className='w-6 h-6 text-gray-400'
          fill='currentColor'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
        >
          <path d='M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z' />
        </svg>
      );
    case "userTesting":
      return (
        <svg
          className={className}
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          viewBox="0 0 308 308"
        >
          <g filter="url(#filter0_d_125_781)">
            <circle cx="154" cy="150" r="150" fill="#F2F2F2"/>
          </g>
          <rect opacity="0.9" x="127" y="144" width="135.5" height="89.552" rx="5" fill="#003766"/>
          <rect x="133.535" y="148.39" width="122.429" height="80.7724" rx="5" fill="#003766"/>
          <rect x="137.892" y="151.462" width="113.715" height="74.6266" rx="5" fill="white"/>
          <rect x="187.997" y="229.162" width="10.0209" height="15.3643" fill="#003766"/>
          <path d="M147.274 244.52C148.224 243.42 149.62 242.771 151.074 242.771H234.505C235.958 242.771 237.355 243.42 238.304 244.52C241.101 247.76 238.868 252.867 234.588 252.867H150.991C146.711 252.867 144.478 247.76 147.274 244.52Z" fill="#003766"/>
          <path d="M47 217.5C47 200.931 60.4315 187.5 77 187.5H96.6121C113.181 187.5 126.612 200.931 126.612 217.5V252H47V217.5Z" fill="#003766"/>
          <ellipse cx="87.2483" cy="132.676" rx="39.3638" ry="39.6756" fill="#003766"/>
          <rect x="120.121" y="199.578" width="54" height="15" rx="5" transform="rotate(60.438 120.121 199.578)" fill="#003766"/>
          <rect x="131" y="238" width="45" height="15" rx="5" fill="#003766"/>
          <mask id="path-11-inside-1_125_781" fill="white">
            <path fillRule="evenodd" clipRule="evenodd" d="M173.513 108.121C173.909 107.095 174.838 106.373 175.924 106.204C199.398 102.534 217 87.2811 217 69.022C217 48.023 193.719 31 165 31C136.281 31 113 48.023 113 69.022C113 87.1452 130.341 102.307 153.553 106.12C154.654 106.301 155.586 107.048 155.965 108.097L161.72 124.043C162.663 126.654 166.341 126.695 167.341 124.105L173.513 108.121Z"/>
          </mask>
          <path fillRule="evenodd" clipRule="evenodd" d="M173.513 108.121C173.909 107.095 174.838 106.373 175.924 106.204C199.398 102.534 217 87.2811 217 69.022C217 48.023 193.719 31 165 31C136.281 31 113 48.023 113 69.022C113 87.1452 130.341 102.307 153.553 106.12C154.654 106.301 155.586 107.048 155.965 108.097L161.72 124.043C162.663 126.654 166.341 126.695 167.341 124.105L173.513 108.121Z" fill="white"/>
          <path d="M167.341 124.105L164.542 123.024L167.341 124.105ZM155.965 108.097L153.143 109.116L155.965 108.097ZM175.924 106.204L175.461 103.24L175.924 106.204ZM214 69.022C214 85.1563 198.222 99.6814 175.461 103.24L176.388 109.168C200.574 105.387 220 89.4058 220 69.022H214ZM165 34C178.791 34 191.155 38.0914 199.999 44.5581C208.845 51.0264 214 59.7117 214 69.022H220C220 57.3334 213.514 47.0077 203.54 39.7147C193.564 32.4202 179.928 28 165 28V34ZM116 69.022C116 59.7117 121.155 51.0264 130.001 44.5581C138.845 38.0914 151.209 34 165 34V28C150.072 28 136.436 32.4202 126.46 39.7147C116.486 47.0077 110 57.3334 110 69.022H116ZM154.039 103.159C131.539 99.4635 116 85.0369 116 69.022H110C110 89.2535 129.143 105.15 153.066 109.08L154.039 103.159ZM164.542 123.024L158.787 107.079L153.143 109.116L158.899 125.061L164.542 123.024ZM170.715 107.04L164.542 123.024L170.139 125.186L176.312 109.202L170.715 107.04ZM158.899 125.061C160.783 130.283 168.139 130.365 170.139 125.186L164.542 123.024C164.536 123.041 164.531 123.05 164.529 123.053C164.528 123.055 164.528 123.054 164.531 123.051C164.534 123.047 164.538 123.043 164.543 123.038C164.549 123.033 164.554 123.03 164.558 123.027C164.567 123.021 164.571 123.02 164.567 123.022C164.565 123.022 164.562 123.023 164.558 123.023C164.553 123.024 164.548 123.024 164.542 123.024C164.537 123.024 164.531 123.024 164.527 123.023C164.522 123.022 164.519 123.022 164.517 123.021C164.513 123.02 164.517 123.02 164.526 123.026C164.531 123.029 164.536 123.033 164.541 123.038C164.546 123.043 164.55 123.047 164.553 123.051C164.556 123.055 164.556 123.056 164.555 123.053C164.553 123.05 164.548 123.041 164.542 123.024L158.899 125.061ZM153.066 109.08C153.098 109.085 153.122 109.098 153.135 109.109C153.147 109.118 153.145 109.121 153.143 109.116L158.787 107.079C158.023 104.963 156.166 103.509 154.039 103.159L153.066 109.08ZM175.461 103.24C173.361 103.568 171.513 104.972 170.715 107.04L176.312 109.202C176.31 109.207 176.308 109.204 176.32 109.195C176.333 109.185 176.356 109.173 176.388 109.168L175.461 103.24Z" fill="#003766" mask="url(#path-11-inside-1_125_781)"/>
          <path d="M154 53.75C156.417 50.7083 159.292 48.875 162.625 48.25C163.625 48.0833 164.667 48 165.75 48C170.958 48 174.708 49.9583 177 53.875C178.25 56 178.917 58.4583 179 61.25C179 63.5417 178.646 65.5833 177.938 67.375C177.229 69.125 176.354 70.4375 175.312 71.3125C174.271 72.1875 173.229 72.9167 172.188 73.5C171.188 74.0417 170.333 74.375 169.625 74.5L168.562 74.6875V81.5625H160.5V67.8125C164.875 67.7292 167.729 67.2083 169.062 66.25C170.354 65.25 171 63.5417 171 61.125C171 58.9167 169.938 57.375 167.812 56.5C166.979 56.1667 166.125 56 165.25 56C162.708 56.0417 160.667 57.0625 159.125 59.0625L154 53.75ZM159.75 88.625C159.75 86.75 160.562 85.3542 162.188 84.4375C162.896 84.0625 163.646 83.875 164.438 83.875C166.312 83.875 167.708 84.6875 168.625 86.3125C169 87.0625 169.188 87.8333 169.188 88.625C169.188 90.5 168.375 91.875 166.75 92.75C166.042 93.125 165.271 93.3125 164.438 93.3125C162.521 93.3125 161.146 92.4792 160.312 90.8125C159.938 90.1042 159.75 89.375 159.75 88.625Z" fill="#003766"/>
          <defs>
            <filter id="filter0_d_125_781" x="0" y="0" width="308" height="308" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_125_781"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_125_781" result="shape"/>
            </filter>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default SvgList;
